<template>
  <div>

    <form class="mt-12" @submit.prevent="onSubmit" v-if="pharmacy">

      <div class="mt-12 font-bold text-xl">
        Fritekst som skal vises på profilen deres:
      </div>

      <button class="text-sm mt-2 text-red-500" @click.prevent="sampleTextVisible = true" v-if="!sampleTextVisible">
        <span v-if="sampleTextVisible">Skjul eksempeltekst</span>
        <span v-else>Vis eksempeltekst</span>
      </button>

      <div v-if="sampleTextVisible" class="relative bg-gray-200 mt-2 text-xs p-2 text-gray-800 rounded shadow">
        <button class="absolute right-0 top-0 m-2" @click.prevent="sampleTextVisible = false">
          <font-awesome-icon class="ml-2" :icon="['far', 'times' ]" size="lg" />
        </button>
        <div class="font-bold">Eksempeltekst:</div>
        <p class="mt-2">"Apoteket" er et hyggelig lite lokalapotek med mange faste kunder, både eldre, yngre og barnefamilier. I 2016 flyttet vi inn i nye, større, lyse lokaler i Gate 9.</p>
        <p class="mt-2">Hos oss jobber det 3 farmasøyter og 2 apotekteknikere, i tillegg til apoteker. Vi har to sertifiserte tjenestefarmasøyter for både Medisinstart og Inhalasjonsveiledning, og alle i apoteket kan sette influensavaksine. Vi har stort engasjement og fagkunnskap innenfor spesielt stomi og inkontinens.</p>
        <p class="mt-2">Vi leverer også legemidler og andre apotekvarer til ulike hjemmesykepleieinstitusjoner og bedrifter i nærmiljøet. For et eldresenter fører vi også farmasøytisk tilsyn. Vi har et godt samarbeid med legene i nærområdet, lokale pasientorganisasjoner og kommunehelsetjenesten. Vi er av og til ute og holder foredrag om riktig legemiddelbruk og hva apoteket kan hjelpe til med.</p>
        <p class="mt-2">Hos oss har vi fokus på fag, god kundeservice og rådgivning, samt rask ekspedering av våre kunder.</p>
        <p class="mt-2">Våre åpningstider er mandag til fredag fra kl 10:00 - 18:00, og lørdag kl 10:00 - 16:00. Søndag er vi stengt.</p>
      </div>

      <div class="mt-4">
        <textarea class="w-full h-64" id="text" ref="text" v-model="pharmacy.description"></textarea>
      </div>

      <div class="mt-12 font-bold text-xl">
        Bilder
      </div>

      <div class="mt-6">
        <transition-group type="transition" name="flip-list">
          <div class="flex items-center justify-between pb-4" v-for="(image, index) in images" :key="image.imageId">
            <div class="w-48 h-32 bg-cover bg-center bg-no-repeat" :style="'background-image:url(' + image.absoluteUri + ')'"/>
            <div class="text-sm uppercase font-bold mainimage" v-if="index === 0">Hovedbilde</div>
            <div class="flex flex-row">
              <div class="p-2 cursor-pointer hover:text-red-500" @click="up(index)" v-show="index > 0">
                <font-awesome-icon  :icon="['far', 'chevron-up']" size="lg" />
              </div>
              <div class="p-2 cursor-pointer hover:text-red-500" @click="down(index)" v-show="index < images.length - 1">
                <font-awesome-icon  :icon="['far', 'chevron-down']" size="lg" />
              </div>
              <div class="p-2 cursor-pointer hover:text-red-500" @click="remove(index)">
                <font-awesome-icon  :icon="['far', 'times']" size="lg" />
              </div>
            </div>
          </div>
        </transition-group>
      </div>

      <div class="mt-6">
        <button class="btn text-sm" @click.prevent="chooseImage">Legg til bilder</button>
        <input type="file" ref="fileInput" accept="image/x-png,image/jpeg" class="hidden" @change="onSelectFile" />
      </div>

      <div class="flex justify-between mt-16">
        <button class="btn" @click.prevent="onPrevClick">
          <font-awesome-icon :icon="['far', 'chevron-left']" />
          <span class="inline-block ml-4">Forrige</span>
        </button>
        <div>
          <button class="btn" @click.prevent="onPreview">Forhåndsvis</button>
          <button class="btn btn-primary ml-2" type="submit">Ferdig</button>
        </div>
      </div>

    </form>

    <modal v-if="previewPharmacy" @close="previewPharmacy = null" :header="previewPharmacy.name">

      <image-carousel class="mb-4" :images="previewPharmacy.images"></image-carousel>

      <h1 class="text-xl font-semibold">{{ previewPharmacy.name }}</h1>
      <div class="flex flex-wrap text-sm leading-loose mt-2 w-2/3 lg:w/1/2">
        <div class="flex flex-row items-center mr-2" v-if="previewPharmacy.address || previewPharmacy.postCode || previewPharmacy.postPlace">
          <font-awesome-icon :icon="['far', 'map-marker']"/>
          <div class="ml-1">{{ previewPharmacy.address ? previewPharmacy.address + ', ': '' }} {{ previewPharmacy.postCode }} {{ previewPharmacy.postPlace }}</div>
        </div>
        <template v-if="previewPharmacy.user">
          <div class="flex flex-row items-center mr-2" v-if="previewPharmacy.user.name">
            <font-awesome-icon :icon="['far', 'user']"/>
            <div class="ml-1">{{ previewPharmacy.user.name }}</div>
          </div>
          <div class="flex flex-row items-center mr-2" v-if="previewPharmacy.user.phone">
            <font-awesome-icon :icon="['far', 'phone']"/>
            <div class="ml-1">{{ previewPharmacy.user.phone }}</div>
          </div>
        </template>
      </div>
      <div class="mt-8">
        <div v-html="previewPharmacy.description"></div>
      </div>
    </modal>

    <modal v-if="modalVisible" @close="onClose" header="Registrering vellykket">
      Registreringen av apoteket er nå fullført. Du kan redigere informasjonen frem til studentene skal velge praksisapotek.
      <div class="xtext-center mt-12">
        <a class="btn btn-primary w-32" href="#" @click.prevent="onClose">Ok</a>
      </div>
    </modal>

  </div>

</template>

<script>
import api from '@/api'
import ImageCarousel from '@/components/ImageCarousel.vue'
import _ from 'lodash'
export default {
  name: 'ap-register-profile',
  components: {
    ImageCarousel
  },
  data () {
    return {
      sampleTextVisible: false,
      previewPharmacy: null,
      modalVisible: false,
      pharmacy: null,
      images: [],
    }
  },
  methods: {
    onPrevClick () {
      this.$emit('prev')
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    async onSelectFile () {
      let input = this.$refs.fileInput
      const files = input.files
      if (files && files[0]) {
        await api.ap.uploadImage(files[0])
        this.images = await api.ap.getImages()
      }
    },
    async onSubmit () {
      await api.ap.updatePharmacy(this.pharmacy)
      this.modalVisible = true
    },
    onClose () {
      this.$emit('submit')
    },
    up (index) {
      const image = this.images[index];
      this.images.splice(index, 1);
      this.images.splice(index - 1, 0, image);
    },
    down (index) {
      const image = this.images[index];
      this.images.splice(index, 1);
      this.images.splice(index + 1, 0, image);
    },
    remove (index) {
      this.images = _.filter(this.images, (w, ix) => index !== ix)
    },
    async onPreview () {
      await api.ap.updatePharmacy(this.pharmacy)
      this.previewPharmacy = await api.ap.getPharmacyPreview()
    }
  },
  async mounted () {
    this.pharmacy = await api.ap.getPharmacy()
    this.images = await api.ap.getImages()
  },
  watch: {
    images: async function (val, old) {
      if (old.length > 0) {
        if (val.length === old.length) {
          await api.ap.updateImagesOrder(_.map(val, v => v.imageId))
          this.$toasted.show('Rekkefølge på bilder lagret!')
        } else {
          const valIds = _.map(val, v => v.imageId)
          const oldIds = _.map(old, o => o.imageId)
          const removedId  = _.difference(oldIds, valIds)
          await api.ap.deleteImage(removedId)
        }
      }
    }
  }
}
</script>

<style>

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #edf0f3;
}

.ghost .mainimage,
.sortable-chosen .mainimage {
  display: none;
}
</style>